<iframe title="hidden IAM check" [src]="keyCloakSessionUrl$ | async" style="display: none"></iframe>
